module.exports = __webpack_public_path__ + "static/media/22ESCWA20.7a8a458c.jpg";